import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton as MuiIconButton, Radio, Tab, Tabs, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import { withStyles } from "@mui/styles";
import PropTypes from 'prop-types';
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import DialogConfirmation from '../../../../components/dialog-confirmation-not-button';
import DialogGeneral from '../../../../components/dialog-general';
import { AbilityContext } from '../../../../config/ability-context';
import * as ItemService from '../../../../services/2talk/channel';
import * as WebchatChannelService from '../../../../services/2talk/webchat-channel.service';
import Api2Talk from '../../../../services/api2talk';
import { Styles } from "../../../../styles/material-styles";

class WebchatChannel extends Component {

  constructor(props) {
    super(props);
    const { webchats } = this.props;
    this.selectedChannelsArray = [];

    this.state = {
      webchatid: webchats.webchat.id,
      channelList: [],
      autocompleteInputValue: '',
      item: {
        selectedOptions: [],
      },
      DialogRemoveState: false,
      IdToDelete: { webchatChannelId: 0, channelId: 0 },
      loadingGrid: false,
      dialogConfirmationOpen: false,
      idToChangeDefault: 0,
      valueToChangeDefault: false,
      identityHashHelpOpen: false,
      snippetTabs: {},
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.openOrCloseRemoveModal = this.openOrCloseRemoveModal.bind(this);
    this.handleDeleteOption = this.handleDeleteOption.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.copyCode = this.copyCode.bind(this);
    this.handleChangeDefault = this.handleChangeDefault.bind(this);
    this.closeDialogConfirmation = this.closeDialogConfirmation.bind(this);
    this.openDialogConfirmation = this.openDialogConfirmation.bind(this);
  }

  async componentDidMount() {
    this.setState({ loadingGrid: true });
    await this.getChannelList();
    await this.getChannelsAssociations();
    this.setState({ loadingGrid: false });
  }

  async getChannelList() {
    const { getNotification, setLoadingState } = this.props;
    const response = await ItemService.getChannelList();

    setLoadingState(false)

    if (response.success) {
      const channels = response.data?.map(channel => ({ id: channel.id, name: channel.name, isdefault: false }));
      this.setState({ channelList: channels });
    } else {
      const intl = this.props.intl;
      getNotification(false, true, 'error', response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
    }
    this.setState({ loadingGrid: false });
  }

  checkValidation() {
    const { getNotification } = this.props;

    let newChannels = this.state.item.selectedOptions?.filter(channel => !channel.webchatchannelid) || [];

    if (newChannels.length == 0) {
      getNotification(false, true, 'error', "Você deve adicionar ao menos um novo canal")
      return false;
    }

    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();

    const { getNotification, setLoadingState } = this.props;

    try {

      let validation = this.checkValidation();

      
      if (validation) {
        setLoadingState(true)

        let input = {
          webchatid: this.state.webchatid,
          channelids: this.state.item.selectedOptions.map(channel => channel.channelid)
        };

        if (Api2Talk == null) {
          getNotification(false, true, 'error', "Api de mensageria não configurada.")
          return;
        }

        const output = await WebchatChannelService.create(input);

        setLoadingState(false)

        if (output.success) {
          await this.getChannelsAssociations();
          getNotification(false, true, 'success', "Canais associados com sucesso");
        } else {
          const intl = this.props.intl;
          getNotification(false, true, 'error', output.errors && output.errors[0] ? output.errors[0] : intl.formatMessage({ id: "process.error" }))

        }
      }

    } catch (err) {
      setLoadingState(true)
      const intl = this.props.intl;
      getNotification(false, true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
    }
  }

  async getChannelsAssociations() {
    const { getNotification } = this.props;
    const intl = this.props.intl;

    try {
      const output = await WebchatChannelService.getChannelsByWebchatId(this.state.webchatid);

      if (output.success) {
        if (output.data && output.data.length > 0) {
          this.updateList(output.data)
        }
      } else {
        getNotification(false, true, 'error', output && output.errors && output.errors[0] ? output.errors[0] : intl.formatMessage({ id: "process.error" }))
      }
    } catch (err) {
      getNotification(false, true, 'error', intl.formatMessage({ id: "process.error" }))
    }
  }

  updateList(list) {
    let array = [];

    list.forEach(element => {
      if (element.id && element.channel) {

        let nameChannel = '';

        if (this.state.channelList.length > 0) {
          let found = this.state.channelList.find(channel => channel.id === element.channel.id);
          nameChannel = found ? found.name : nameChannel;
        }

        let object = {
          channelwebchatid: element.id,
          webchatid: this.state.webchatid,
          channelid: element.channel.id,
          id: element.id,
          name: nameChannel,
          token: element?.token,
          scriptname: element?.scriptname ?? "",
          isdefault: element.isdefault
        }

        array.push(object);
      }
    });

    this.setState((prevState) => ({
      item: {
        ...prevState.item,
        selectedOptions: array,
      }
    }));
  }

  handleAutocompleteChange = (_, newValue) => {
    const { getNotification } = this.props;

    if (newValue) {
      const channelAlreadySelected = this.state.item.selectedOptions?.find(channelSelected => channelSelected?.channelid === newValue?.id);

      if (channelAlreadySelected) {
        getNotification(false, true, 'error', "O canal já está associado ao webchat.");
        return;
      } else {
        this.setState((prevState) => ({
          item: {
            ...prevState.item,
            selectedOptions: [...prevState.item.selectedOptions, { ...newValue, channelid: newValue?.id }],
          },
          autocompleteInputValue: '',
        }));
      }
    }
  };

  async handleDeleteOption() {
    const { getNotification, setLoadingState } = this.props;
    const intl = this.props.intl;

    if (
      this.state.IdToDelete
      && this.state.IdToDelete.channelwebchatid
      && this.state.IdToDelete.channelwebchatid != 0
    ) {

      this.openOrCloseRemoveModal()
      setLoadingState(true)

      try {
        const output = await WebchatChannelService.deleteByChannelWebchatById(this.state.IdToDelete.channelwebchatid);

        setLoadingState(false)

        if (output.success) {
          this.setState((prevState) => ({
            item: {
              ...prevState.item,
              selectedOptions: prevState.item.selectedOptions.filter((option) => option.channelwebchatid !== this.state.IdToDelete.channelwebchatid),
            },
          }));
          getNotification(false, true, 'success', "Canal deletado com sucesso")
          this.setState({ DialogRemoveState: false, IdToDelete: { channelwebchatid: 0 } });

        } else {
          getNotification(false, true, 'error', output && output.errors && output.errors[0] ? output.errors[0] : intl.formatMessage({ id: "process.error" }))
        }
      } catch (err) {
        setLoadingState(false)
        getNotification(false, true, 'error', intl.formatMessage({ id: "process.error" }))
      }

    }
  }

  handleRemoveOption = (optionToRemove) => {
    if (optionToRemove.channelwebchatid) {
      this.setState({ DialogRemoveState: true, IdToDelete: { channelwebchatid: optionToRemove.channelwebchatid } })
    }
    else {
      this.setState((prevState) => ({
        item: {
          ...prevState.item,
          selectedOptions: prevState.item.selectedOptions.filter((option) => option.id !== optionToRemove.id),
        },
      }));
    }
  };

  filterOptions = (options, { inputValue }) => {
    const { selectedOptions } = this.state.item;
    return options.filter(
      (option) =>
        !selectedOptions.find((selected) => selected.channelid === option.id) &&
        !this.state.item.selectedOptions.find((selected) => selected.channelid === option.id)
    );
  };

  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true });
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));
  }

  openOrCloseRemoveModal = () => {
    this.setState({ DialogRemoveState: false })
  }

  copyCode = (token, script) => {
    const { getNotification, intl } = this.props;
    navigator.clipboard.writeText(`<!-- WebChat 2TALK start --> \n <script> \n var _2talk_chatclientkey = "${token}"; \n </script> \n <script src="${script}"></script> \n <!-- WebChat 2TALK end -->`)
    getNotification(false, true, 'success', intl.formatMessage({ id: "webchat.channel.copied" }))
  }

  // Deriva a URL do loader a partir do scriptname do canal.
  // Produção usa o minificado (loader.min.js); homologa/dev/localhost usam o editável (loader.js).
  // (ex.: https://webchat.mexx.ai/2talk-widget.js -> https://webchat.mexx.ai/loader.min.js)
  getLoaderSrc = (script) => {
    if (!script) return "https://webchat.mexx.ai/loader.min.js";
    const isProd = !/(homologa|dev\.|localhost)/.test(script);
    const fileName = isProd ? 'loader.min.js' : 'loader.js';
    return script.replace(/[^/]*$/, fileName);
  }

  // Snippet simples (modelo legado: chatclientkey global + script do widget). String para preview/cópia.
  buildSimpleSnippet = (token, script) => {
    return `<!-- WebChat 2TALK start -->
<script>
  var _2talk_chatclientkey = "${token}";
</script>
<script src="${script}"></script>
<!-- WebChat 2TALK end -->`;
  }

  // Syntax highlight leve (sem libs) para HTML + JS. Retorna HTML com <span> coloridos.
  // Conteúdo dinâmico (token) é escapado; só os <span> que injetamos não são — seguro contra XSS.
  highlightCode = (code) => {
    const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const C = { comment: '#6a9955', string: '#ce9178', keyword: '#569cd6', func: '#dcdcaa' };
    const re = /(<!--[\s\S]*?-->)|(\/\/[^\n]*)|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|\b(var|function|window|document|new|return|true|false|null)\b|\b(Mexx2Talk)\b/g;
    let out = '', last = 0, m;
    while ((m = re.exec(code)) !== null) {
      out += esc(code.slice(last, m.index));
      let color = C.func;
      if (m[1] || m[2]) color = C.comment;
      else if (m[3]) color = C.string;
      else if (m[4]) color = C.keyword;
      else if (m[5]) color = C.func;
      out += '<span style="color:' + color + '">' + esc(m[0]) + '</span>';
      last = m.index + m[0].length;
    }
    out += esc(code.slice(last));
    return out;
  }

  // Gera o snippet avançado (loader + boot + identify). Usado para copiar e para o preview.
  buildAdvancedSnippet = (token, script) => {
    const loaderSrc = this.getLoaderSrc(script);
    return `<!-- WebChat 2TALK start -->
<script>
  // 1) Instalação do widget (cole uma única vez no seu sistema)
  (function(){var w=window,d=document;
    var q=w.Mexx2Talk=w.Mexx2Talk||function(){(w.Mexx2Talk.q=w.Mexx2Talk.q||[]).push(arguments)};
    var s=d.createElement('script');s.async=1;s.src="${loaderSrc}";
    d.head.appendChild(s);})();

  // 2) Inicializa o widget (mostra o ícone na página)
  Mexx2Talk('boot', { chatClientKey: "${token}" });

  // 3) Identifique o usuário logado no SEU sistema.
  //    Pode ser chamado a qualquer momento (inclusive de forma assíncrona, após buscar a
  //    sessão do usuário), SEM recarregar a página.
  //    organizationKey + userLogin + loginType são OBRIGATÓRIOS.
  //    Quando o usuário clicar no ícone, o atendimento abre já identificado (sem formulário).
  Mexx2Talk('identify', {
    organizationKey: "<código da organização no seu sistema>",
    userLogin:       "<email | cpf | celular do usuário>",
    loginType:       1, // 1=Email, 2=CPF, 3=Celular
    userKey:         "<id do usuário no seu sistema (opcional)>",
    userName:        "<nome do usuário (opcional)>",
    // identityHash: obrigatório SOMENTE se a Verificação de Identidade estiver ativa no seu canal.
    // Gere no SEU backend: HMAC_SHA256(secret, userLogin) em hexadecimal minúsculo.
    identityHash:    "<HMAC gerado no seu backend (opcional)>"
  });
</script>
<!-- WebChat 2TALK end -->`;
  }

  copyCodeWithExternalIdentity = (token, script) => {
    const { getNotification } = this.props;
    navigator.clipboard.writeText(this.buildAdvancedSnippet(token, script));
    getNotification(false, true, 'success', this.props.intl.formatMessage({ id: "webchat.channel.copied" }))
  }

  setSnippetTab = (key, value) => {
    this.setState(prev => ({ snippetTabs: { ...prev.snippetTabs, [key]: value } }));
  }

  handleChangeDefault = async () => {
    const id = this.state.idToChangeDefault
    const value = this.state.valueToChangeDefault
    var options = this.state.item.selectedOptions

    if (value == true) {
      await WebchatChannelService.setDefault(id)
      for (let i = 0; i < options.length; i++) {
        if (options[i].id == id) {
          options[i].isdefault = true
        } else {
          options[i].isdefault = false
        }
      }
    } 

    this.setState(prevState => ({
      ...prevState,
      item: {
        selectedOptions: options
      },
      dialogConfirmationOpen: false
    }))
  }

  closeDialogConfirmation() {
    this.setState({ dialogConfirmationOpen: false })
  }

  openDialogConfirmation = async (id, value) => {
    if (!value) {
      this.setState({ dialogConfirmationOpen: true, idToChangeDefault: id, valueToChangeDefault: true })
    } else {
      await WebchatChannelService.setNotDefault(id)
      
      var options = this.state.item.selectedOptions;

      for (let i = 0; i < options.length; i++) {
        if (options[i].id == id) {
          options[i].isdefault = false
          break
        }
      }

      this.setState(prevState => ({
        ...prevState,
        item: {
          selectedOptions: options
        },
        dialogConfirmationOpen: false
      }))
    }
  }

  render() {

    const { classes, intl } = this.props;
    const { item, channelList, autocompleteInputValue, loadingGrid } = this.state;

    // Estilo discreto para termos técnicos inline (não herda o tamanho grande do <code> nativo)
    const codeStyle = {
      fontFamily: 'monospace',
      fontSize: '11px',
      background: '#f0f0f0',
      color: '#333',
      padding: '1px 4px',
      borderRadius: '3px',
    };

    // Blocos de código do modal de ajuda do identityHash
    const preStyle = {
      fontFamily: 'monospace',
      fontSize: '12px',
      background: '#1a1a2e',
      color: '#e0e0e0',
      padding: '10px 12px',
      borderRadius: '6px',
      overflowX: 'auto',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      margin: '4px 0 12px',
    };

    return (

      <div>
        <form name='myForm' className={classes.form} encType='multipart/form-data' onSubmit={this.handleSubmit}>
          <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={12}>
              <Autocomplete
                value={null}
                inputValue={autocompleteInputValue}
                options={channelList}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Canais" variant="outlined" fullWidth />
                )}
                renderOption={(props, option, state) => (
                  <>
                    <List>
                      <ListItem {...props}>
                        <ListItemText primary={option.name} />
                      </ListItem>
                      {state.index < channelList.length - 1 && <Divider />}
                    </List>
                  </>
                )}
                onChange={this.handleAutocompleteChange}
                filterOptions={this.filterOptions}
                changeSelect={this.changeValues}
                onInputChange={(_, newInputValue) => this.setState({ autocompleteInputValue: newInputValue })}
                fullWidth
              />

              <div>
                {loadingGrid ? (
                  <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
                ) : (
                  item.selectedOptions.map((option, index) => {
                    const tabKey = option.id ?? index;
                    const snippetTab = this.state.snippetTabs[tabKey] ?? 0;
                    const truncToken = option.token !== undefined
                      ? (option.token.substring(0, 30) + (option.token.length > 30 ? '...' : ''))
                      : '';
                    const simplePreview = option.token !== undefined
                      ? this.buildSimpleSnippet(truncToken, option.scriptname)
                      : '';
                    const advancedPreview = option.token !== undefined
                      ? this.buildAdvancedSnippet(truncToken, option.scriptname)
                      : '';
                    // Estilos compartilhados entre as duas abas (layout idêntico)
                    const codeBoxStyle = {
                      fontFamily: 'monospace', fontSize: '11px', background: '#1e1e1e',
                      color: '#d4d4d4', padding: '12px 44px 12px 12px', borderRadius: '6px',
                      overflowX: 'auto', maxHeight: '280px', overflowY: 'auto', margin: 0,
                      whiteSpace: 'pre', wordBreak: 'normal', lineHeight: 1.5
                    };
                    const infoBoxStyle = { fontSize: '12px', color: '#666', margin: '10px 0 4px 0', lineHeight: 1.6 };
                    // Botão de copiar afastado da borda para não ficar sob a barra de rolagem
                    const copyBtnPosStyle = { position: 'absolute', top: 6, right: 18 };
                    return (
                    <div key={index} style={{ padding: '16px', marginTop: '16px', border: '1px solid #ccc' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <b>
                          Canal : {option.name}
                        </b>
                        <IconButton color="secondary" onClick={() => this.handleRemoveOption(option)}>
                          <DeleteIcon />
                        </IconButton>
                      </div>

                      {option.token !== undefined
                        ? (
                          <div>
                            <Tabs
                              value={snippetTab}
                              onChange={(e, v) => this.setSnippetTab(tabKey, v)}
                              variant="fullWidth"
                              indicatorColor="primary"
                              textColor="primary"
                              style={{ minHeight: 36, marginBottom: 12 }}
                            >
                              <Tab style={{ minHeight: 36, textTransform: 'none' }} label={intl.formatMessage({ id: "webchat.channel.tab.simple" })} />
                              <Tab style={{ minHeight: 36, textTransform: 'none' }} label={intl.formatMessage({ id: "webchat.channel.tab.advanced" })} />
                            </Tabs>

                            {/* ===== Aba: Versão simples ===== */}
                            {snippetTab === 0 && (
                              <div style={{ marginBottom: '20px' }}>
                                <div style={{ position: 'relative' }}>
                                  <pre style={codeBoxStyle} dangerouslySetInnerHTML={{ __html: this.highlightCode(simplePreview) }} />
                                  <div style={copyBtnPosStyle}>
                                    <Tooltip title={<h5>{intl.formatMessage({ id: "webchat.channel.copy.simple.tooltip" })}</h5>}>
                                      <IconButton aria-label="textevidence" size="small"
                                        onClick={() => this.copyCode(option.token, option.scriptname)}>
                                        <FileCopyIcon style={{ color: '#8BC34A' }} />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div style={infoBoxStyle}>
                                  {intl.formatMessage({ id: "webchat.channel.simple.explain" })}
                                </div>
                              </div>
                            )}

                            {/* ===== Aba: Versão avançada (loader + API) ===== */}
                            {snippetTab === 1 && (
                              <div style={{ marginBottom: '20px' }}>
                                <div style={{ position: 'relative' }}>
                                  <pre style={codeBoxStyle} dangerouslySetInnerHTML={{ __html: this.highlightCode(advancedPreview) }} />
                                  <div style={copyBtnPosStyle}>
                                    <Tooltip title={<h5>{intl.formatMessage({ id: "webchat.channel.copy.advanced.tooltip" })}</h5>}>
                                      <IconButton aria-label="copywithexternalidentity" size="small"
                                        onClick={() => this.copyCodeWithExternalIdentity(option.token, option.scriptname)}>
                                        <FileCopyIcon style={{ color: '#8BC34A' }} />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div style={infoBoxStyle}>
                                  <FormattedMessage
                                    id="webchat.channel.advanced.explain"
                                    values={{
                                      code: (chunks) => <span style={codeStyle}>{chunks}</span>,
                                      link: (chunks) => (
                                        <a
                                          href="#"
                                          onClick={(e) => { e.preventDefault(); this.setState({ identityHashHelpOpen: true }); }}
                                          style={{ color: '#277afe', fontWeight: 600, textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                          {chunks}
                                        </a>
                                      )
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                              <b>
                                <FormattedMessage id='default' />
                              </b>
                              <Radio
                                name={option.id}
                                checked={option.isdefault}
                                onClick={(e) => this.openDialogConfirmation(option.id, option.isdefault)} />
                            </div>
                          </div>
                        )
                        : (
                          <div />
                        )}

                    </div>
                    );
                  })

                )}
              </div>

            </Grid>

            <Grid container style={{ marginTop: '25px' }}>
              <Grid item xs={4} />
              <Grid item xs={4} />
              <Grid item xs={4} container alignItems="flex-end" justifyContent="flex-end">
                <Button variant="contained" color="primary" type="submit" fullWidth>
                  Salvar
                </Button>
              </Grid>
            </Grid>

          </Grid>
        </form>

        <DialogGeneral
          dialogTitle={"Remover canal do webchat"}
          dialogSubTitle={"Você deseja remover esse canal ?"}
          open={this.state.DialogRemoveState}
          openOrCloseModalFunction={this.openOrCloseRemoveModal}
          handleConfirmation={this.handleDeleteOption}
        />

        {this.state.dialogConfirmationOpen && <DialogConfirmation
          msgButton={intl.formatMessage({ id: "confirm" })}
          msg={intl.formatMessage({ id: "webchat.channel.default" })}
          msgDisagree={intl.formatMessage({ id: "cancel" })}
          msgAgree={intl.formatMessage({ id: "confirm" })}
          handleConfirmation={e => this.handleChangeDefault()}
          handleClose={e => this.closeDialogConfirmation()}
          classes={classes}
          disabled={false}
          icon={<DeleteIcon />}
        />}

        <Dialog
          open={this.state.identityHashHelpOpen}
          onClose={() => this.setState({ identityHashHelpOpen: false })}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { maxHeight: '90vh' } }}
        >
          <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
            {intl.formatMessage({ id: "webchat.channel.identity.modal.title" })}
            <MuiIconButton
              aria-label="close"
              onClick={() => this.setState({ identityHashHelpOpen: false })}
              sx={{ position: 'absolute', right: 8, top: 8, color: '#888' }}
            >
              <CloseIcon />
            </MuiIconButton>
          </DialogTitle>
          <DialogContent dividers>
            <div style={{ fontSize: '13px', color: '#333', lineHeight: 1.6, overflowY: 'auto', maxHeight: '70vh', paddingRight: '8px' }}>
              <p style={{ marginTop: 0 }}>
                <b>O que é.</b> Mecanismo que impede que um usuário forje a identidade de outro no
                navegador — equivalente ao <i>Identity Verification</i> do Intercom/Zendesk. Sem ele,
                qualquer pessoa poderia chamar <span style={codeStyle}>Mexx2Talk('identify', &#123;...&#125;)</span> com
                o login de terceiros.
              </p>

              <p>
                <b>Contrato.</b> O <span style={codeStyle}>identityHash</span> é um HMAC-SHA256 calculado
                <b> no backend do cliente</b> (o secret nunca vai para o navegador):
              </p>
              <pre style={preStyle}>identityHash = HMAC_SHA256( key = secret_do_webchat , message = userLogin )  → hexadecimal minúsculo</pre>

              <ul style={{ marginTop: 0, paddingLeft: 18 }}>
                <li><b>key</b>: o secret do webchat (gerado na tela de Verificação de Identidade do webchat).</li>
                <li><b>message</b>: o <span style={codeStyle}>userLogin</span> exatamente como enviado no identify (com trim nas pontas), independente do loginType.</li>
                <li><b>saída</b>: hexadecimal minúsculo (não base64).</li>
              </ul>

              <p style={{ marginBottom: 4 }}><b>Exemplos de geração no backend:</b></p>
              <p style={{ margin: '6px 0 2px' }}><b>C#</b></p>
              <pre style={preStyle}>{`using var hmac = new HMACSHA256(Encoding.UTF8.GetBytes(secret));
var bytes = hmac.ComputeHash(Encoding.UTF8.GetBytes(userLogin.Trim()));
var identityHash = Convert.ToHexString(bytes).ToLowerInvariant();`}</pre>
              <p style={{ margin: '6px 0 2px' }}><b>Node.js</b></p>
              <pre style={preStyle}>{`const identityHash = require('crypto')
  .createHmac('sha256', secret).update(userLogin.trim()).digest('hex');`}</pre>
              <p style={{ margin: '6px 0 2px' }}><b>PHP</b></p>
              <pre style={preStyle}>{`$identityHash = hash_hmac('sha256', trim($userLogin), $secret);`}</pre>
              <p style={{ margin: '6px 0 2px' }}><b>Python</b></p>
              <pre style={preStyle}>{`import hmac, hashlib
identity_hash = hmac.new(secret.encode(), user_login.strip().encode(), hashlib.sha256).hexdigest()`}</pre>

              <p>
                <b>Quando é exigido.</b> Apenas quando o webchat tem um secret configurado. Sem secret,
                a verificação não é exigida (a integração funciona só com organizationKey + userLogin + loginType).
                Com secret configurado, o <span style={codeStyle}>identityHash</span> torna-se
                <b> obrigatório</b>: se vier ausente ou divergente, o atendimento automático é recusado
                e o usuário cai no formulário de identificação tradicional.
              </p>

              <p style={{ marginBottom: 0 }}>
                <b>Importante.</b> O <span style={codeStyle}>userLogin</span> usado no cálculo do HMAC deve
                ser idêntico (mesmo trim, mesma capitalização) ao enviado no identify. Guarde o secret
                apenas no backend — nunca exponha no navegador.
              </p>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}


WebchatChannel.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  userSession: state.userSession,
  webchats: state.webchats
});


export default injectIntl(withRouter(connect(mapStateToProps)(withStyles(Styles)(WebchatChannel))));
WebchatChannel.contextType = AbilityContext;